var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9862 1.53264C10.382 1.15579 9.61864 1.15578 9.01445 1.53264L2.13943 5.82087C2.05556 5.87319 1.97673 5.93154 1.90332 5.99516L8.6597 12.0276C8.66395 12.0313 8.66814 12.0351 8.67233 12.0389L9.58408 12.8529C9.8212 13.0647 10.1795 13.0647 10.4166 12.8529L11.3283 12.0389C11.3325 12.0351 11.3367 12.0313 11.341 12.0276L18.0973 5.99516C18.024 5.93154 17.9451 5.87319 17.8612 5.82088L10.9862 1.53264Z",
    fill: "#4DA528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7503 13.3379L11.249 13.7854C10.5377 14.4206 9.46288 14.4206 8.75151 13.7854L8.25026 13.3379L2.36816 18.5898C2.59916 18.6927 2.8551 18.75 3.12526 18.75H16.8753C17.1454 18.75 17.4014 18.6927 17.6323 18.5898L11.7503 13.3379Z",
    fill: "#4DA528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5404 17.7253L12.6875 12.4996L18.7223 7.11133C18.74 7.21564 18.7491 7.32214 18.7491 7.42977V16.8576C18.7491 17.1694 18.6739 17.4648 18.5404 17.7253Z",
    fill: "#4DA528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45871 17.7253L7.31156 12.4996L1.27674 7.11133C1.25908 7.21564 1.25 7.32214 1.25 7.42977V16.8576C1.25 17.1694 1.32519 17.4648 1.45871 17.7253Z",
    fill: "#4DA528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.625,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounmail);
export default __webpack_public_path__ + "static/media/nounmail.189961e42d468a356ec692a1ec28e01c.svg";
export { ForwardRef as ReactComponent };